import { get  ,ref} from 'firebase/database';
import React , {useEffect , useState} from 'react';
import {db} from "../../config/firebase_config.js";
import UserModel from '../../models/user_model.js';



const UserQR = ({phoneNo}) => {

    const [imageUrl, setImageUrl] = useState("");


    const QRCodeImage = async() => {

        const databaseRef = ref( db , `Users/${phoneNo}`);
        const snapshot = await get(databaseRef);
        console.log(">---------  searching for user data  -----------<")
        if(snapshot.exists()){
          console.log(">---------  got the results ra ayya  -----------<")
          const  data = snapshot.val()
          console.log(`>---------  ${data}  -----------< `)
          const userInfo = UserModel.fromJson(data);
          const decodedUrl = atob(userInfo.myQrCode); 
          const imageUrl = `data:image/png;base64,${userInfo.myQrCode}`;
          setImageUrl(imageUrl);
              
      }
  
       
      }; 

      useEffect(() => {
        QRCodeImage();
       }, [])
      


  return (
  <div className='handle-qr' >
    {
        imageUrl != "" 
        ? <img src={imageUrl} alt="QR Code" width={"125px"} height={"125px"}  />
        : <div className='load-qr'></div>
    }
  </div>
   
  )
}

export default UserQR
